import { gql } from "@medbillai/generated-graphql-types";

/** The profile identity a check sends; setup asks only for what's missing. */
export const coverageSetupIdentityQuery = gql(/* GraphQL */ `
  query CoverageSetupIdentity {
    me {
      id
      acceptedTermsAt
      primaryPerson {
        id
        givenNames
        familyName
        dateOfBirth
      }
    }
  }
`);
